/* src/app/components/core/layout/footer/font-selector/font-selector.component.css */
.font-selector {
  font-weight: 300;
}
/*# sourceMappingURL=font-selector.component-WBHHRMOO.css.map */
